import React, { ReactNode, memo } from "react";
import { SpaceProps } from "antd";
import { createUseStyles } from "react-jss";
import { COLORS } from "core/src";

const useStyle = createUseStyles<string, unknown, COLORS>((colors) => ({
  root: {
    width: "100%",
    height: "100vh",
    textAlign:'center',
    margin:'0px',
    display:'flex',
    justifyContent:'center'
  },
  innercard: {
    borderRadius: "10px",
    width: "90%",
    height: "95vh",
    boxShadow: `1px 2px 10px ${colors.theme01}`,
    backgroundColor: colors.black,
    textAlign: "center",
    margin:"30px",
    display:"flex",
    justifyContent:'center',
    alignItems:'center',
  },
}));
interface Props extends SpaceProps {
  children?: ReactNode;
}
const Paper = memo<Props>(({ children }) => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <div className={classes.innercard}>{children}</div>
    </div>
  );
});

export { Paper };
